import { useTheme } from '@material-ui/core';
import useIsMobile from '../../react/useIsMobile';
import { ISpcTheme } from '../../theme/ISpcTheme';

const useAdditionalScrollMargin = (): number => {
  const {
    spc: {
      customise: { additionalScrollMargin },
    },
  } = useTheme<ISpcTheme>();
  const isMobile = useIsMobile();

  if (!additionalScrollMargin) {
    return 0;
  }

  return isMobile ? additionalScrollMargin.mobile : additionalScrollMargin.desktop;
};

export default useAdditionalScrollMargin;
